import { Routes, Route } from 'react-router-dom';
import PortalLayout from '../shared/components/PortalLayout';
import { useAuth, userIsSupervisor } from '../context/AuthContext';
import RequestListPage from './pages/RequestListPage';
import RequestCreatePage from './pages/RequestCreatePage';
import RequestDetailPage from './pages/RequestDetailPage';
import PTOReviewListPage from './pages/PTOReviewListPage';
import AdminCalendarPage from './pages/AdminCalendarPage';

export default function VacationPortal() {
  const { user } = useAuth();
  const isSup = userIsSupervisor(user);

  return (
    <PortalLayout activeModule="vacaciones">
      <Routes>
        {/* Employee routes (everyone) */}
        <Route index element={<RequestListPage />} />
        <Route path="nueva" element={<RequestCreatePage />} />
        <Route path=":id" element={<RequestDetailPage />} />

        {/* Supervisor/admin approval queue */}
        {isSup && <Route path="revision" element={<PTOReviewListPage />} />}
        {isSup && <Route path="calendario" element={<AdminCalendarPage />} />}
      </Routes>
    </PortalLayout>
  );
}
